import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { DateTimeService } from '../../services/date-time.service';
import { UserInfoService } from '../../services/user-info.service';
import { StorageService } from '../../services/storage.service';


@Component({
  selector: 'lib-lpco-approval',
  templateUrl: './lpco-approval.component.html',
})
export class LpcoApprovalComponent implements OnInit {

  public lpcoApprovalGroup: FormGroup;
  public lpcoStatusList: any[] = [];
  public rejectionReasonList: any[] = [];
  public formData:any = { 'variables': {} };
  public goodsDetailAction= [];
  public load = false;
  public showrejectionReason = false;
  public showRemarks = false;
  @Input() public defaultFormData: string[];
  @Output() public submitedFormData = new EventEmitter<FormData>();

  constructor(private formBuilder: FormBuilder, private dataTimeService: DateTimeService, private storage: StorageService, public userInfo: UserInfoService) { }

  ngOnInit():void  {
    if (typeof this.defaultFormData === 'object') {
      this.onLoad(this.defaultFormData);
      this.load = true;

    }

  }

  onLoad(data:any):void  {
    this.lpcoApprovalGroup = this.formBuilder.group({
      lpcoStatus: [null, [Validators.required]],
      rejectionReason: [null],
      remarks: [null]
    });

    const keys = Object.keys(data.rdmData);
    keys.forEach((key) => {
      if (key.indexOf('ics_label_status') >= 0) {
        this.lpcoStatusList = data.rdmData[key];
      } else {
        this.rejectionReasonList = data.rdmData[key];
      }
    });

  }

  lpcoStatusChange(value: string):void  {
    const lpcoStatus = this.lpcoApprovalGroup.controls['lpcoStatus'];
    const rejStatus = this.lpcoApprovalGroup.controls['rejectionReason'];
    const appRemark = this.lpcoApprovalGroup.controls['remarks'];
    if (value.includes('Approved')) {
      this.showrejectionReason = false;
      lpcoStatus.setValidators(Validators.required);
      rejStatus.clearValidators();
      appRemark.clearValidators();
    } else if (value.includes('Rejected')) {
      this.showrejectionReason = true;
      rejStatus.setValidators([Validators.required]);
      appRemark.setValidators([Validators.required]);
      lpcoStatus.clearValidators();
    } else {
      this.showrejectionReason = false;
      rejStatus.clearValidators();
      lpcoStatus.clearValidators();
    }

  }


  onSubmit():void {
    for (const i in this.lpcoApprovalGroup.controls) {
      if(i in this.lpcoApprovalGroup.controls){
        this.lpcoApprovalGroup.controls[i].markAsDirty();
        this.lpcoApprovalGroup.controls[i].updateValueAndValidity();
      }
    }

    if (this.lpcoApprovalGroup.value.lpcoStatus !== null) {
      this.formData.variables['status'] = { 'value': this.lpcoApprovalGroup.value.lpcoStatus };
    }

    if (this.lpcoApprovalGroup.value.rejectionReason !== null) {
      this.formData.variables['rejectionReasonCode'] = { 'value': this.lpcoApprovalGroup.value.rejectionReason };
    }

    if (this.lpcoApprovalGroup.value.remarks !== null) {
      this.formData.variables['reviewerRemarks'] = { 'value': this.lpcoApprovalGroup.value.remarks };
    }

    this.formData.variables['action'] = { 'value': this.lpcoApprovalGroup.value.lpcoStatus };
    this.formData.variables['operation'] = { 'value':  this.lpcoApprovalGroup.value.lpcoStatus };


    if (this.lpcoApprovalGroup.valid) {
      this.submitedFormData.emit(this.formData);
    }

  }


}
